import { useState } from "react";
import { IoIosAddCircleOutline } from "react-icons/io";
import { IoCheckmarkCircleOutline } from "react-icons/io5";
import { useDispatch } from "react-redux";
import { driverService } from "../../Services/driver.service";
import DeleteModal from "../Components/Modals/Delete-modal";
import Spinner from "../Components/Spinner";
import { ToastComponent } from "../Components/ToastComponent";
import { useTranslation } from "react-i18next";
import {
  GridComponent,
  Page,
  Inject,
  ColumnDirective,
  ColumnsDirective,
  Filter,
} from "@syncfusion/ej2-react-grids";

export default function DriverProfile(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  dispatch({ type: "title", value: `${t("DRIVER_PROFILE.VEHICLES")}: ${props.driverName}` });

  const [toastParams, setToastParams] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [isDeleting, setIsDeleting] = useState({
    show: false,
    itemName: "",
    itemRemoveId: 0,
  });

  const onSaveLink = (vehicleId) => {
    try {
      setIsLoading(true);
      const formattedPayload = {
        driverId: props.driverId,
        vehicleIds: [vehicleId],
      };
      driverService.linkVehicleToDriver(formattedPayload);
    } catch (error) {
      setToastParams(
        JSON.stringify({
          show: true,
          title: t("COMMON.ERROR"),
          body: t("ERRORS.SAVE_LINK_ERROR"),
          color: "Danger",
        })
      );
    } finally {
      setIsLoading(false);
      props.handleClose();
    }
  };

  const onDeleteLink = (vehicleId) => {
    try {
      setIsLoading(true);
      const formattedPayload = {
        driverId: props.driverId,
        vehicleIds: [vehicleId],
      };
      driverService.unlinkVehicleToDriver(formattedPayload);
    } catch (error) {
      setToastParams(
        JSON.stringify({
          show: true,
          title: t("COMMON.ERROR"),
          body: t("ERRORS.REMOVE_LINK_ERROR"),
          color: "Danger",
        })
      );
    } finally {
      setIsLoading(false);
      props.handleClose();
    }
  };

  return (
    <div className="card mb-4">
      <ToastComponent
        params={toastParams}
        closeToast={() => setToastParams(JSON.stringify({ show: false }))}
      />
      <DeleteModal
        itemName={isDeleting.itemName}
        itemRemoveId={isDeleting.itemRemoveId}
        callBackRemove={onDeleteLink}
        show={isDeleting.show}
        handleClose={() =>
          setIsDeleting({ show: false, itemName: "", itemRemoveId: "" })
        }
      />
      {isLoading ? (
        <Spinner />
      ) : (
        <div style={{ marginTop: 16 }}>
          <GridComponent
            dataSource={props.vehicles}
            allowPaging={true}
            pageSettings={{ pageSize: 13 }}
            allowFiltering={false}
            rowHeight={30}
            height={"auto"}
            locale="pt-BR"
          >
            <ColumnsDirective>
              <ColumnDirective
                field="plate"
                headerText={t("DRIVER.PLATE")}
                width="130"
                template={(props) => (
                  <div className="tooltipReport">
                    <span>{props.plate} </span>
                    <span className="tooltipReportText">{props.plateTooltip}</span>
                  </div>
                )}
              />
              <ColumnDirective
                headerText={t("DRIVER.LINKED")}
                width="100"
                template={(props) => (
                  <div>
                    {props.linked === "S" ? (
                      <IoCheckmarkCircleOutline
                        className="icon-button"
                        color="green"
                        onClick={() => {
                          setIsDeleting({
                            show: true,
                            itemName: props.plate,
                            itemRemoveId: props.vehicleId,
                          });
                        }}
                      />
                    ) : (
                      <IoIosAddCircleOutline
                        className="icon-button"
                        color="blue"
                        onClick={() => onSaveLink(props.vehicleId)}
                      />
                    )}
                  </div>
                )}
              />
            </ColumnsDirective>
            <Inject services={[Page, Filter]} />
          </GridComponent>
        </div>
      )}
      <div className="row justify-content-end" style={{ textAlign: "end" }}>
        <div className="col-lg-12 col-md-12 col-xs-12 d-flex flex-wrap justify-content-end gap-2">
          <button
            type="button"
            className="btn btn-warning"
            onClick={props.handleClose}
          >
            {t("BUTTONS.CLOSE")}
          </button>
        </div>
      </div>
    </div>
  );
}